import { NgModule } from '@angular/core';
import { TableSortDirective } from '../core/util/table-sort.directive';
import { CommonModule, JsonPipe } from '@angular/common';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UppNotificationComponent } from './upp-notification/upp-notification.component';
import { LoadingAlertComponent } from './loading-alert/loading-alert.component';
import { ShowValidationErrorComponent } from './show-validation-error/show-validation-error.component';
import { AutoFocusDirective } from './auto-focus/auto-focus.directive';
import { CriteriaListComponent } from './criteria/criteria-list/criteria-list.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MultiSelectBadgesComponent } from './multi-select-badges/multi-select-badges.component';
import { DfDatePickerModule, DfDatepickerRangeService, DfSelectModule } from '@design-factory/design-factory';
import { ButtonGroupComponent } from './button-group/button-group.component';
import { LookupSelectComponent } from './lookup-select/lookup-select.component';
import { ValidationErrorMessageComponent } from './validation-error-message/validation-error-message.component';
import { CheckboxMultiselectComponent } from './checkbox-multiselect/checkbox-multiselect.component';
import { RuleDateRangeComponent } from './rule-date-range/rule-date-range.component';
import { CustomDateParserFormatter } from './rule-date-range/custom-date-parser.service';

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    ReactiveFormsModule,
    FormsModule,
    DfSelectModule,
    JsonPipe,
    DfDatePickerModule,
    TableSortDirective,
    UppNotificationComponent,
    AutoFocusDirective,
    LoadingAlertComponent,
    ShowValidationErrorComponent,
    CriteriaListComponent,
    MultiSelectBadgesComponent,
    ButtonGroupComponent,
    LookupSelectComponent,
    ValidationErrorMessageComponent,
    CheckboxMultiselectComponent,
    RuleDateRangeComponent
  ],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    { provide: 'DfDatepickerRangeService2', useClass: DfDatepickerRangeService },
    DfDatepickerRangeService
  ],
  exports: [
    TableSortDirective,
    UppNotificationComponent,
    LoadingAlertComponent,
    ShowValidationErrorComponent,
    AutoFocusDirective,
    CriteriaListComponent,
    MultiSelectBadgesComponent,
    ButtonGroupComponent,
    LookupSelectComponent,
    ValidationErrorMessageComponent,
    CheckboxMultiselectComponent,
    RuleDateRangeComponent
  ]
})
export class ComponentsModule {}
